(function() {
    'use strict';

    angular
        .module('exportsApp')
        .controller('ExportsRollbackDialogController', ExportsRollbackDialogController);

    ExportsRollbackDialogController.$inject = ['$scope', '$uibModalInstance','transferRequestDTO','ExportsService'];

    function ExportsRollbackDialogController($scope, $uibModalInstance,transferRequestDTO,ExportsService) {
    	var rollbackExportsCtr=this;
    	rollbackExportsCtr.transferRequestDTO=transferRequestDTO;
    	rollbackExportsCtr.ok=function() {
    		ExportsService.post({uri:'doRollBackRequest'},rollbackExportsCtr.transferRequestDTO, 
    	    		 function (result){
    	    			 if (result.flagError!=null&&result.flagError==0) {
    	    				 $uibModalInstance.close(true);
    	    			 }
    	    		 }, function (error){
    	    			 if(error.data.errorDTO != null){
    	    				 rollbackExportsCtr.errorMessage = error.data.errorDTO.message;
    	         		}
    	    		 });  
    	};

    	rollbackExportsCtr.cancel=function() {
    	    $uibModalInstance.dismiss('cancel');
    	};
    	rollbackExportsCtr.errorMessage = null;
    	function cancel() {
    	   $uibModalInstance.dismiss('cancel');
    	};
    }
})();
